import { ComponentPropsWithoutRef } from 'react'
import { cn } from '~shared/utils/cn'
import { ImageSrc } from '~shared/types/utils'
import Image from 'next/image'
import { replacePrepositionsWhitespaces } from '~shared/utils/replace-prepositions-whitespaces'

interface CourseOutComeSectionCardProps extends ComponentPropsWithoutRef<'li'> {
  title: string
  label: string
  img: ImageSrc
  index: string
}

const CourseOutComeSectionCard = (props: CourseOutComeSectionCardProps) => {
  const { className = '', title, label, index, img, ...rest } = props

  return (
    <li
      className={cn('relative rounded-[24px] bg-secondary', className)}
      {...rest}>
      <Image
        src={img}
        alt='Decoration'
        height={155}
        width={155}
        className={cn(
          'select-none absolute right-0 size-[131px]',
          'top-1/2 -translate-y-1/2',
          'md:top-0 md:translate-y-0  md:size-[155px]',
          'lg:top-1/2 lg:-translate-y-1/2',
          'xl:top-0 xl:translate-y-0',
          '2xl:size-[188px]'
        )}
        draggable={false}
      />
      <p className='absolute top-card-inner-indent left-card-inner-indent'>
        {index}
      </p>
      <div className='absolute inset-card-inner-indent top-auto md:right-card-inner-indent right-[110px] lg:right-[155px] xl:right-card-inner-indent'>
        <p className='w-full tracking-[-0.01em] leading-[1] font-medium text-[16px] md:text-[20px] xl:text-[24px]'>
          {replacePrepositionsWhitespaces(title)}
        </p>
        <p className='w-full mt-2 md:mt-4 text-[14px] md:text-[16px]'>
          {replacePrepositionsWhitespaces(label)}
        </p>
      </div>
    </li>
  )
}

const config = [
  {
    title: 'Получите',
    label: 'знания и навыки практикующего психолога',
    img: '/assets/imgs/main-page/our-advantages-section1.png'
  },
  {
    title: 'Сможете',
    label:
      'выявить мотивы обращения клиента и установить с ним  доверительные отношения',
    img: '/assets/imgs/main-page/our-advantages-section2.png'
  },
  {
    title: 'Поймете',
    label:
      'как и о чем общаться с людьми, испытывающими трудности в деликатных вопросах',
    img: '/assets/imgs/main-page/our-advantages-section3.png'
  },
  {
    title: 'Научитесь',
    label: 'проводить групповые и  индивидуальные консультации',
    img: '/assets/imgs/main-page/our-advantages-section4.png'
  }
]

export interface CourseOutComeSectionProps
  extends ComponentPropsWithoutRef<'section'> {}

export const CourseOutComeSection = (props: CourseOutComeSectionProps) => {
  const { className = '', ...rest } = props

  return (
    <section className={cn('container container-slim', className)} {...rest}>
      <h2 className='typo-section-heading text-center max-w-[875px] mx-auto'>
        В результате прохождения курса&nbsp;вы
      </h2>
      <ul
        className={cn(
          'grid gap-4 xl:mb-[80px]',
          //   'mt-[30px] md:mt-[24px] lg:mt-[40px] xl:mt-[60px]',
          'grid-cols-1 grid-rows-[repeat(4,160px)]',
          'md:grid-cols-2 md:grid-rows-[260px_260px]',
          'ld:grid-rows-[222px_222px]',
          'xl:md:grid-cols-4 xl:grid-rows-[300px]',
          '2xl:grid-rows-[372px]'
        )}>
        {config.map(({ title, label, img }, index) => (
          <CourseOutComeSectionCard
            key={`0${index + 1}.`}
            index={`0${index + 1}.`}
            title={title}
            label={label}
            img={img}
            className={cn(
              (index === 1 || index === 2) && 'xl:translate-y-[80px]'
            )}
          />
        ))}
      </ul>
    </section>
  )
}
